import { render, staticRenderFns } from "./category.vue?vue&type=template&id=4f279a1a&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f279a1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f279a1a')) {
      api.createRecord('4f279a1a', component.options)
    } else {
      api.reload('4f279a1a', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=4f279a1a&scoped=true&", function () {
      api.rerender('4f279a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/category.vue"
export default component.exports